import { LicenseMonthlyServicesFormWebComponent } from './component/LicenseMonthlyServicesFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_SERVICES_FORM } from '../../../webcomponents.constants';

export { LicenseMonthlyServicesFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_MONTHLY_SERVICES_FORM, LicenseMonthlyServicesFormWebComponent);
